import React, { useEffect, useRef, useState } from "react";
import ProfileCard from "./profile-card";
import Menu from "./menu";

import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../../reducer/slices/user/userSlice";
import { logout } from "../../../reducer/slices/user/userSlice";

const ProfileButton = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const { userProfile, isLoading } = useSelector((state) => state.user);
  const initials = `${userProfile.firstName?.charAt(0).toUpperCase() || ""}${userProfile.lastName?.charAt(0).toUpperCase() || ""}`;
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    if (userProfile && !userProfile.userID) {
      dispatch(fetchUserProfile({}));
    }
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleLogout = () => {
    dispatch(logout({}));
  };

  return (
    <div className="relative inline-block text-left">
      {/* Profile Icon */}
      <div
        className="profile-initials text-white font-[500] rounded-full w-9 h-9 text-[14px] flex items-center justify-center cursor-pointer gradient-text border border-[#E2E7F8]"
        onClick={toggleDropdown}
        ref={dropdownRef}
      >
        {/* {isLoading?<div className="mini-spinner"></div>:initials}
         */}
        {initials}
      </div>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div className="absolute right-0 mt-2 w-[400px] h-[198px] bg-white border border-gray-200 rounded-lg shadow-lg z-10">
          <ProfileCard
            firstName={userProfile.firstName}
            name={`${userProfile.firstName} ${userProfile.lastName}`}
            lastName={userProfile.lastName}
            email={userProfile.email}
            image={userProfile.profileImage}
          />
          <Menu onPersonalInfoClick={() => {}} onLogoutClick={handleLogout} />
        </div>
      )}
    </div>
  );
};

export default ProfileButton;
